export function getYandexClientID() {
  const match = document.cookie.match("(?:^|;)\\s*_ym_uid=([^;]*)");
  return match ? decodeURIComponent(match[1]) : false;
}

export function getGoogleClientID() {
  let match = document.cookie.match("(?:^|;)\\s*_ga=([^;]*)");
  const raw = match ? decodeURIComponent(match[1]) : null;
  if (raw) {
    match = raw.match(/(\d+\.\d+)$/);
  }
  const gacid = match ? match[1] : null;
  if (gacid) {
    return gacid;
  }
}

export function initClientIDs(
  selectors = { ya: ".js--cid_ya", g: ".js--cid_g" }
) {
  const yaCid = getYandexClientID() ?? "";
  const gCid = getGoogleClientID() ?? "";
  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(selectors.ya)?.forEach((input) => {
      input.value = yaCid;
    });
    document.querySelectorAll(selectors.g)?.forEach((input) => {
      input.value = gCid;
    });
  });
}
